import { render } from "./inviate.vue?vue&type=template&id=338701e1&scoped=true"
import script from "./inviate.vue?vue&type=script&lang=js"
export * from "./inviate.vue?vue&type=script&lang=js"

import "./inviate.vue?vue&type=style&index=0&id=338701e1&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338701e1"]])

export default __exports__